import { ID } from '@griply/types';

// Later lists win on collisions; a lone non-empty list keeps its identity for memos.
export const dedupeTasksById = <T extends { id: ID }>(
  ...taskLists: T[][]
): T[] => {
  const nonEmpty = taskLists.filter((list) => list.length);
  if (!nonEmpty.length) {
    return [];
  }
  if (nonEmpty.length === 1) {
    return nonEmpty[0];
  }

  const byId = new Map<ID, T>();
  nonEmpty.forEach((list) => list.forEach((task) => byId.set(task.id, task)));
  return Array.from(byId.values());
};
